import React from "react";
import { TableHeader, TableBody, TableRow, TableFooter } from '../../../common/table'

const headers = [
  { name: "ID", column: "id", sort: true },
  { name: "STATUS", column: "status", sort: true },
  { name: "CHAIN", column: "chain", sort: true },
  { name: "SECONDARY CHAIN", column: "chain", sort: true },
  { name: "NAME", column: "name", sort: true },
  { name: "DISPLAY NAME", column: "display_name", sort: true },
  { name: "#", column: "chain_number", sort: false },
  { name: "ADDRESS", column: "address", sort: true },
  { name: "CITY", column: "city", sort: true },
  { name: "STATE", column: "state_code", sort: true },
  { name: "ZIP", column: "zipcode", sort: true },
  { name: "COUNTRY", column: "country", sort: true },
  { name: "LAT", column: "latitude", sort: true },
  { name: "LONG", column: "longitude", sort: true },
  { name: "COMDATA ID", column: "comdata_id", sort: true },
  { name: "EFS ID", column: "efs_id", sort: true },
  { name: "MSFUELCARD ID", column: "msfuelcard_id", sort: true },
  { name: "QUIKQ ID", column: "quikq_id", sort: true },
  { name: "RELAY ID", column: "relay_id", sort: true },
  { name: "CREATED", column: "created_at", sort: true },
  { name: "UPDATED", column: "updated_at", sort: true }
];

const fields = [
  { name: "id" },
  { name: "status" },
  { name: "chain.name" },
  { name: "secondary_chain.name" },
  {
    name: "name",
    render: (item) =>
      item.google_place_url ? (
        <a href={item.google_place_url} target="_blank" rel="noopener noreferrer" className="text-underline">
          {item.name}
        </a>
      ) : (
        item.name
      ),
  },
  { name: "display_name" },
  { name: "chain_number" },
  { name: "address" },
  { name: "city" },
  { name: "state_code" },
  { name: "zipcode" },
  { name: 'country' },
  { name: "latitude" },
  { name: "longitude" },
  { name: "comdata_id" },
  { name: "efs_id" },
  { name: "msfuelcard_id" },
  { name: "quikq_id" },
  { name: "relay_id" },
  {
    name: "created_at",
    render: (item) => new Date(item.created_at).toLocaleDateString("en-US"),
  },
  {
    name: "updated_at",
    render: (item) => new Date(item.updated_at).toLocaleDateString("en-US"),
  },
  {
    name: "id",
    key: "edit",
    render: (item) => <a href={`/locations/${item.id}/edit`}>Edit</a>,
  },
];

const LocationTable = ({ locations, query, updatePagination, updateSort }) => {
  return (
    <div className="mt-4 flow-root mb-8">
      <div className='shadow ring-1 ring-black/5'>
        <div className="overflow-y-scroll overflow-x-auto max-h-[550px]">
          <div className="h-full overflow-y-auto">
            <table className="min-w-full divide-y divide-gray-300">
              <TableHeader
                headers={headers}
                sortDir={query.sort_direction}
                updateSort={updateSort}
                activeColumn={query.sort_column}
              />
              <TableBody rows={locations}>
                {(row, idx) => (
                  <TableRow key={row.id} item={row} fields={fields} />
                )}
              </TableBody>
            </table>
          </div>
        </div>

        <TableFooter
          colSpan={headers.length}
          query={query}
          updatePagination={updatePagination}
        />
      </div>
    </div>
  );
};

export default LocationTable;
